export const discountConstants = {
    DISCOUNT_ADD_SETTINGS_REQUEST: 'DISCOUNT_ADD_SETTINGS_REQUEST',
    DISCOUNT_ADD_SETTINGS_SUCCESS: 'DISCOUNT_ADD_SETTINGS_SUCCESS',
    DISCOUNT_ADD_SETTINGS_FAILURE: 'DISCOUNT_ADD_SETTINGS_FAILURE',

    DISCOUNT_GET_SETTINGS_REQUEST: 'DISCOUNT_GET_SETTINGS_REQUEST',
    DISCOUNT_GET_SETTINGS_SUCCESS: 'DISCOUNT_GET_SETTINGS_SUCCESS',
    DISCOUNT_GET_SETTINGS_FAILURE: 'DISCOUNT_GET_SETTINGS_FAILURE',

    DISCOUNT_EDIT_SETTINGS_REQUEST: 'DISCOUNT_EDIT_SETTINGS_REQUEST',
    DISCOUNT_EDIT_SETTINGS_SUCCESS: 'DISCOUNT_EDIT_SETTINGS_SUCCESS',
    DISCOUNT_EDIT_SETTINGS_FAILURE: 'DISCOUNT_EDIT_SETTINGS_FAILURE',

    DISCOUNT_DELETE_SETTINGS_REQUEST: 'DISCOUNT_DELETE_SETTINGS_REQUEST',
    DISCOUNT_DELETE_SETTINGS_SUCCESS: 'DISCOUNT_DELETE_SETTINGS_SUCCESS',
    DISCOUNT_DELETE_SETTINGS_FAILURE: 'DISCOUNT_DELETE_SETTINGS_FAILURE',

    GET_ACTIVE_DISCOUNT_REQUEST: 'GET_ACTIVE_DISCOUNT_REQUEST',
    GET_ACTIVE_DISCOUNT_SUCCESS: 'GET_ACTIVE_DISCOUNT_SUCCESS',
    GET_ACTIVE_DISCOUNT_FAILURE: 'GET_ACTIVE_DISCOUNT_FAILURE',

   


};
